<template>
  <div class="custom-item">
    <el-checkbox v-model="dragConfig.isShow" @change="onCheckboxChange"><span
        style="color: #fff;">速度图表</span></el-checkbox>
    <el-checkbox v-model="isDefault"><span style="color: #fff;">默认开启</span></el-checkbox>
  </div>
  <chart-lists />
  <g-drag-resize :config="dragConfig">
    <template #default>
      <div class="Chart-box">
        <div class="close" @click="dragConfig.isShow = false">
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2134" width="35"
            height="35">
            <path
              d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
              p-id="2135" fill="#ffffff"></path>
          </svg>
        </div>
        <div class="Chart" ref="chart"></div>
      </div>
    </template>
  </g-drag-resize>
</template>

<script>
import { defineComponent, reactive, watch, computed } from 'vue';
import * as echarts from 'echarts';
import { round } from 'lodash';
import { useStore } from '@/store/index';
import moment from 'moment';
import GDragResize from '@/components/GDragResize/index.vue';
import { dayjs } from 'element-plus';
import styles from '@/views/Home/component/Bottom/component/FormSwitch/index.module.less';
import ChartLists from '@/views/Home/component/Bottom/component/ChartList/index.vue'
import { ElDialog, ElTable } from 'element-plus';
import { useFrameDataStore } from "@/store/frameDataStore";
let store;

export default defineComponent({
  name: 'SpeedChart',
  data() {
    return {
      dragConfig: {
        minW: 300,
        minH: 200,
        isShow: JSON.parse(localStorage.getItem('isOpenSpeedChart')) || false,
        nameSpace: 'speedChart',
        x: 0,
        y: 0,
        w: window.innerWidth - 500,
        h: 200,
        name: 'speedChart',
        customClass: 'speed-chart-popover',
      },
      styles,
      showLists: false,
      chartInitialized: false,
      isDefault: JSON.parse(localStorage.getItem('isOpenSpeedChart')) || false,
    };
  },
  components: {
    GDragResize,
    ChartLists,
    ElDialog,
    ElTable
  },
  props: {
    speedList: {
      default: [],
    },
  },
  created() {
    store = useStore();
  },
  mounted() {
    this.onCheckboxChange();
    let speedChart = JSON.parse(localStorage.getItem('speedChart'))
    if (speedChart) {
      this.dragConfig.w = speedChart.w
      this.dragConfig.h = speedChart.h
    }
  },
  methods: {
    close() {
      this.dragConfig.isShow = false;
    },
    initData(newValue, option, ts, legend) {
      const createSeries = (newValue, name, color) => {
        return {
          data: newValue.map(({ speed, velocity, msgTime }) => [
            msgTime,
            round(name === '底盘速度' ? speed : velocity, 3), // 根据系列名称选择速度值 ]),  
          ]),
          type: 'line',
          lineStyle: {
            width: 1,
          },
          symbol: ([time]) => {
            return moment(ts).startOf('second').valueOf() ===
              moment(time).valueOf()
              ? 'emptyCircle'
              : 'diamond';
          },
          symbolSize: ([time]) => {
            return moment(ts).startOf('second').valueOf() ===
              moment(time).valueOf()
              ? 10
              : 2;
          },
          itemStyle: {
            color: color,
          },
          lineStyle: {
            color: color,
          },
          name: name,
        }
      }

      return {
        legend: {
          ...legend,
          textStyle: {
            color: '#fff'
          },
          right: 100,
        },
        ...option,
        backgroundColor: '#022641',
        color: '#fff',
        series: [
          createSeries(newValue, '定位速度', '#1E90FF'),
          createSeries(newValue, '底盘速度', '#FFA500')
        ],
      };
    },
    initChart(){
    let frameDataStore = useFrameDataStore();
    const chartDom = this.$refs.chart;
    const myChart = echarts.init(chartDom);
    const resizeObserver = new ResizeObserver((entries, observer) => {
      entries.forEach((entry) => {
        myChart.resize();
      });
    });

    resizeObserver.observe(chartDom);

    const legend = reactive({
      data: ['定位速度', '底盘速度'],
      selected: {
        定位速度: true,
        底盘速度: true
      },
      right: 100,
      orient: 'horizontal',
      textStyle: {
        color: '#fff'
      },
    })

    const option = reactive({
      title: {
        text: '速度',
        padding: [5, 0, 0, 0],
        textStyle: {
          color: '#fff',
        },
      },
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '1%',
        right: '4%',
        bottom: '4%',
        top: '15%',
        containLabel: true,
      },
      xAxis: {
        type: 'time',
        axisLabel: {
          show: true,
          interval: 4,
          showMaxLabel: true,
        },
        axisTick: {
          inside: true,
        },
        minorTick: {
          show: true,
          splitNumber: 5,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      animation: false,
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%'],
        splitLine: {
          show: false,
        },
        max: function (value) {
            return Math.ceil(value.max)
        }
      },
      lineStyle: {
        color: '#1efff7',
      },
      label: {
        color: '#fff',
      },
    });
    myChart.setOption(this.initData(this.speedList, option, legend));

    myChart.off('click');

    myChart.on('click', (params) => {
      if (params?.data && params?.data?.length) {
        const time = params.data[0];

        // store.commit('wsModule/clearPrevCache');
        // store.dispatch('wsModule/WS_SendProgress', );
        frameDataStore.setCurrentTime(dayjs(time).valueOf())
      }
    });

    myChart.on('legendselectchanged', function (params) {
        legend.selected = params.selected;
    });

    watch(
      computed(() => this.$props.speedList),
      (newList) => {
        const newoption = this.initData(newList, option, legend);

        if (newoption) {
          myChart.setOption(newoption, true);
        }
      },
    );

    watch(
      computed(() => frameDataStore.currentTime),
      (ts) => {
        const newoption = this.initData(this.$props.speedList, option, ts,legend);
        if (newoption) {
          myChart.setOption(newoption, true);
        }
      },
    );
    },
    onCheckboxChange(){
      if (this.dragConfig.isShow && !this.chartInitialized) {
        this.initChart(); // 初始化图表
        this.chartInitialized = true; // 设置标记为已初始化
      }
    }
  },
  watch: {
    isDefault: {
      handler(newVal) {
        localStorage.setItem('isOpenSpeedChart', newVal)
      },
    },
  }
});
</script>
<style scoped lang="less">
.speed-chart-popover {
  position: fixed;

  z-index: 5000;

  .Chart-box {
    width: 100%;
    height: 100%;
    padding: 10px;
    margin: 0 auto;
    box-sizing: border-box;
    background: url(@/assets/images/modal-bg.png) no-repeat;
    background-size: 100% 100%;
    box-shadow: 0 0 16px #ccc;

    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 22;
      cursor: pointer;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;

      svg {
        width: 20px;
      }
    }

    .Chart {
      padding: 0 10px;
      width: 100%;
      height: 100%;
      background: #022641;
    }
  }
}

.custom-item {
  padding: 0 10px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}
</style>